export interface BusinessAddress {
  street?: string;
  city?: string;
  postalCode?: string;
  state?: string;
  countryOrRegion?: string;
}

export interface HomeAddress {
  street?: string;
  city?: string;
  postalCode?: string;
  state?: string;
  countryOrRegion?: string;
}

export interface OtherAddress {
  street?: string;
  city?: string;
  postalCode?: string;
  state?: string;
  countryOrRegion?: string;
}

export type OutlookColor = 
  | 'Red' | 'Orange' | 'Brown' | 'Yellow' | 'Green' | 'Teal' | 'Olive' | 'Blue' | 'Purple' 
  | 'Cranberry' | 'Steel' | 'DarkSteel' | 'Gray' | 'DarkGray' | 'Black' | 'DarkRed' 
  | 'DarkOrange' | 'DarkBrown' | 'DarkYellow' | 'DarkGreen' | 'DarkTeal' | 'DarkOlive' 
  | 'DarkBlue' | 'DarkPurple' | 'DarkCranberry';

export const OUTLOOK_COLORS: Array<{ name: OutlookColor; hex: string; preset: string }> = [
  // Row 1 (preset0-9)
  { name: 'Red', hex: '#E74856', preset: 'preset0' },
  { name: 'Orange', hex: '#F7630C', preset: 'preset1' },
  { name: 'Brown', hex: '#8E562E', preset: 'preset2' },
  { name: 'Yellow', hex: '#FFD700', preset: 'preset3' },
  { name: 'Green', hex: '#10893E', preset: 'preset4' },
  { name: 'Teal', hex: '#00B7C3', preset: 'preset5' },
  { name: 'Olive', hex: '#647C64', preset: 'preset6' },
  { name: 'Blue', hex: '#0078D4', preset: 'preset7' },
  { name: 'Purple', hex: '#8764B8', preset: 'preset8' },
  { name: 'Cranberry', hex: '#C50F3C', preset: 'preset9' },
  
  // Row 2 (preset10-19)
  { name: 'Steel', hex: '#69797E', preset: 'preset10' },
  { name: 'DarkSteel', hex: '#4A5459', preset: 'preset11' },
  { name: 'Gray', hex: '#7F7F7F', preset: 'preset12' },
  { name: 'DarkGray', hex: '#505050', preset: 'preset13' },
  { name: 'Black', hex: '#1D1D1D', preset: 'preset14' },
  { name: 'DarkRed', hex: '#A4262C', preset: 'preset15' },
  { name: 'DarkOrange', hex: '#CA5010', preset: 'preset16' },
  { name: 'DarkBrown', hex: '#663D00', preset: 'preset17' },
  { name: 'DarkYellow', hex: '#986F0B', preset: 'preset18' },
  { name: 'DarkGreen', hex: '#004B1C', preset: 'preset19' },
  
  // Row 3 (preset20-24)
  { name: 'DarkTeal', hex: '#005B70', preset: 'preset20' },
  { name: 'DarkOlive', hex: '#063D0F', preset: 'preset21' },
  { name: 'DarkBlue', hex: '#002050', preset: 'preset22' },
  { name: 'DarkPurple', hex: '#401B6C', preset: 'preset23' },
  { name: 'DarkCranberry', hex: '#75172E', preset: 'preset24' },
];

export interface SmartCategory {
  id: string;
  user_id: string;
  name: string;
  color: OutlookColor;
  tags: string[];
  description?: string;
  is_active?: boolean;
  created_at: string;
  updated_at: string;
}

export interface CategoryClassification {
  category: string | null;
  confidence: 'high' | 'medium' | 'low';
  reasoning: string;
}

export interface ParsedContact {
  // Name
  title?: string;
  givenName: string;
  surname: string;
  middleName?: string;
  suffix?: string;
  nickname?: string;
  displayName?: string;
  
  // Yomi
  yomiGivenName?: string;
  yomiSurname?: string;
  
  // Business
  companyName: string;
  yomiCompanyName?: string;
  department?: string;
  jobTitle: string;
  profession?: string;
  officeLocation?: string;
  manager?: string;
  assistantName?: string;
  
  // Emails
  emailAddresses: string[];
  
  // Phones
  businessPhones: string[];
  homePhones?: string[];
  otherPhones?: string[];
  mobilePhone: string;
  assistantPhone?: string;
  carPhone?: string;
  radioPhone?: string;
  callback?: string;
  pager?: string;
  ttytddPhone?: string;
  telex?: string;
  companyMainPhone?: string;
  
  // Fax
  businessFax?: string;
  homeFax?: string;
  otherFax?: string;
  
  // Web
  businessHomePage: string;
  personalWebPage?: string;
  
  // IM/Social
  imAddresses?: string[];
  
  // Addresses
  businessAddress?: BusinessAddress;
  homeAddress?: HomeAddress;
  otherAddress?: OtherAddress;
  
  // Personal
  spouseName?: string;
  generation?: string;
  birthday?: string;
  anniversary?: string;
  schools?: string;
  hobby?: string;
  location?: string;
  
  // AI/Meta
  hasImageSignature?: boolean;
  imageUrls?: string[];
  categories?: string[];
  categoryColor?: OutlookColor;
  categoryConfidence?: 'high' | 'medium' | 'low';
  notes?: string;
  
  // Partial extraction metadata
  _partialExtraction?: boolean;
  _missingFields?: string[];
  _smartCategoryApplied?: boolean;
}


export interface SmartNotesTask {
  id: string;
  user_id: string;
  title: string;
  prompt: string;
  is_default: boolean;
  created_at: string;
  updated_at: string;
}

export interface SmartNotesSettings {
  enable_smart_notes: boolean;
  auto_run_smart_notes: boolean;
}

export interface SmartNotesResult {
  note: string;
  sources?: string[];
  confidence: 'high' | 'medium' | 'low';
}
